import { useState } from "react";
import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "../lib/auth";
import { fmtErr } from "../lib/api";
import { Button } from "../components/ui/button";
import { BrandLogo } from "../components/BrandLogo";

export default function Login() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  if (user) return <Navigate to="/" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(email, password);
    } catch (err) {
      setError(fmtErr(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="grid min-h-screen lg:grid-cols-[1.1fr_1fr]">
      <div className="relative hidden overflow-hidden lg:block">
        <img src="/brand/warehouse.jpg" alt="Warehouse" className="absolute inset-0 h-full w-full object-cover opacity-40" />
        <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/60 to-transparent" />
        <div className="absolute bottom-0 p-12">
          <p className="eyebrow text-rose-400">Fire - COSHH - PUWER - Maintenance - CAPA</p>
          <h1 className="font-display mt-2 text-6xl font-extrabold uppercase leading-[0.9]">Audit ready.<br />Every shift.</h1>
          <p className="mt-4 max-w-md text-slate-300">UK Compliance Control for DC's, Manufacturing & Office facilities.</p>
        </div>
      </div>
      <div className="grid-bg flex items-center justify-center p-6">
        <form onSubmit={submit} className="fade-up w-full max-w-sm space-y-5" data-testid="login-form">
          <div>
            <BrandLogo fifty className="h-10 max-w-full" testid="login-brand-logo" />
            <p className="font-display mt-4 text-2xl font-extrabold uppercase leading-none">Compliance Pro</p>
            <p className="eyebrow mt-1">Sign in to your site</p>
          </div>
          <label className="block space-y-1.5"><span className="eyebrow">Email</span>
            <input className="field" type="email" autoComplete="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email-input" required />
          </label>
          <label className="block space-y-1.5"><span className="eyebrow">Password</span>
            <input className="field" type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password-input" required />
          </label>
          {error && <p className="rounded border border-red-500/40 bg-red-500/10 p-2 text-sm text-red-300" data-testid="login-error">{error}</p>}
          <Button type="submit" disabled={busy} className="h-12 w-full bg-rose-600 text-base hover:bg-rose-700" data-testid="login-submit-button">
            {busy ? <Loader2 className="h-5 w-5 animate-spin" /> : "Sign in"}
          </Button>
          <p className="text-xs text-slate-500">Accounts are created by your administrator. No public sign-up.</p>
        </form>
      </div>
    </div>
  );
}
